import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import { FONT_SIZE_BUTTON_DATA_HOOK } from './data-hooks';

export type FontSizeTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => {
      getFontSizeValue: () => Promise<string>;
      setFontSizeValue: (value: string) => Promise<void>;
      click: () => Promise<void>;
      clickModalValue: (value: string) => Promise<void>;
    };
  };
}>;

export const createFontSizeTestkit: FontSizeTestkit = getBase => {
  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => {
        const getButton = async () => getTextButtonBase().get(dataHook(FONT_SIZE_BUTTON_DATA_HOOK));
        const getInput = async () => (await getButton()).get('input');
        const getInputValue = async () => {
          const input = await getInput();
          return await input.value();
        };
        const getModal = async () => getBase().get(dataHook('toolbars-modal-desktopPanel'));
        return {
          getFontSizeValue: getInputValue,
          setFontSizeValue: async value => {
            const input = await getInput();
            await input.enterValue(value);
          },
          click: async () => {
            const button = await getButton();
            await button.click();
          },
          clickModalValue: async value => {
            const modal = await getModal();
            const options = await modal.getAll(dataHook('modal-option'));
            const optionsByValue = options.filter(async option => {
              const text = await option.text();
              return text.includes(value);
            });
            await optionsByValue.at(0).click();
          },
        };
      },
    },
  };
};
